import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
export default class MatchInfoNotification extends Notification {
  icon() {
    const data = this.attrs.notification.content() || {};
    switch (data.change_type) {
      case 'time_confirmed':
      case 'time_changed':
        return 'fas fa-calendar-alt';
      case 'tv_added':
        return 'fas fa-tv';
      case 'press_conference_added':
      case 'post_press_added':
        return 'fas fa-microphone';
      case 'callup_added':
        return 'fas fa-clipboard-list';
      case 'referees_assigned':
        return 'fas fa-balance-scale';
      case 'highlights_added':
        return 'fas fa-video';
      default:
        return 'fas fa-futbol';
    }
  }
  href() {
    const data = this.attrs.notification.content() || {};
    const match = this.attrs.notification.subject();
    const matchId = (match && typeof match.id === 'function' ? match.id() : null) || data.match_id;
    const season = data.season;
    const baseUrl = season ? app.route('calendarSeason', {
      season
    }) : app.route('calendarBase');
    return matchId ? "".concat(baseUrl, "#partido-").concat(matchId) : baseUrl;
  }
  content() {
    const data = this.attrs.notification.content() || {};
    const match = this.attrs.notification.subject();
    const rivalName = match && match.rival && match.rival() && match.rival().name() || match && match.opponent && match.opponent() || 'el próximo partido';
    switch (data.change_type) {
      case 'time_confirmed':
        return "Hora confirmada: Athletic vs ".concat(rivalName);
      case 'time_changed':
        return "Horario modificado: Athletic vs ".concat(rivalName);
      case 'tv_added':
        return "Canal de TV confirmado: Athletic vs ".concat(rivalName);
      case 'press_conference_added':
        return "Rueda de prensa previa: Athletic vs ".concat(rivalName);
      case 'callup_added':
        return "Convocatoria oficial: Athletic vs ".concat(rivalName);
      case 'referees_assigned':
        return "\xC1rbitros asignados: Athletic vs ".concat(rivalName);
      case 'post_press_added':
        return "Rueda de prensa post-partido: Athletic vs ".concat(rivalName);
      case 'highlights_added':
        return "V\xEDdeo resumen disponible: Athletic vs ".concat(rivalName);
      default:
        return "Novedades del partido: Athletic vs ".concat(rivalName);
    }
  }
  excerpt() {
    const data = this.attrs.notification.content() || {};
    if (data.tv_channel) {
      return "Televisi\xF3n: ".concat(data.tv_channel);
    }
    return '';
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/notifications/MatchInfoNotification', MatchInfoNotification);